import { makeStyles } from '@material-ui/core/styles'

const drawerWidth = 300
const collapsedDrawerWidth = 84

export const lgStyles = makeStyles((theme) => ({
    root: {
        display: 'flex'
    },
    appBar: {
        width: props => props.isCollapsed ? `calc(100% - ${collapsedDrawerWidth}px)` : `calc(100% - ${drawerWidth}px)`,
        marginLeft: props => props.isCollapsed ? collapsedDrawerWidth : drawerWidth,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawer: {
        width: props => props.isCollapsed ? collapsedDrawerWidth : drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaper: {
        width: props => props.isCollapsed ? collapsedDrawerWidth : drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        overflowX: 'hidden',
    },
    drawerPaperMobile: {
        width: drawerWidth,
        overflowX: 'hidden',
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        width: 'calc(100% - 300px)',
        maxWidth: '100%',
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
        marginLeft: 0,
        transition: theme.transitions.create(['width', 'margin-left'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        '&.collapsed-sidebar': {
            width: 'calc(100% - 84px)',
        }
    },
    toggleButton: {
        backgroundColor: '#014671',
        color: '#ffffff',
        border: '1px solid rgba(0, 0, 0, 0.08)',
        borderRadius: '4px',
        padding: 2,
        width: 20,
        height: 20,
        boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.3)',
        transition: theme.transitions.create(['margin', 'transform'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        '&:hover': {
            backgroundColor: '#0b5e94',
        },
        '&.always-visible-toggle': {
            display: 'flex'
        }
    },
    // New styles for collapsible sidebar elements
    sidebarLogo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        width: '100%',
        flexDirection: 'row',
        transition: 'all 0.3s',
        marginTop: props => props.isCollapsed ? '0px': '10px',
        marginBottom: props => props.isCollapsed ? '0px': '20px',
        padding: props => props.isCollapsed ? '4px 0' : '0',
        overflow: 'hidden',
        position: 'relative',
        zIndex: 10,
        background: '#fff'
    },
    logoContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        width: '100%',
        // maxWidth: '200px'
    },
    logo: {
        height: '30px',
        width: '100%',
        objectFit: 'contain'
    },
    collapsedLogo: {
        opacity: 1,
        transition: 'opacity 0.3s',
        height: '50px',
        width: '50px'
    },
    collapseButtonContainer: {
        transition: 'all 0.3s',
        marginLeft: '5px',
        marginRight: '0px',
        marginTop: '5px'
    },
    collapsedButtonContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'end',
        width: 'auto'
    },
    collapsedToggleButton: {
        transition: 'all 0.3s',
        marginLeft: '10px',
        // margin: '0 0 0 10px',
        width: '20px',
        height: '20px'
    },
    zeroListPadding: {
        padding: '0'
    },
    userAvatarSmall: {
        width: 25,
        height: 25
    },
    userProfileDetails: {
        paddingLeft: '8px',
        textAlign: 'start'
    },
    listItemIconCenter: {
        alignItems: 'center'
    }
}))


export const mdStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: '100%',
        marginLeft: 0
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerPaperMobile: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(10, 2),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: '100%',
        marginLeft: 0
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
    toolbar: theme.mixins.toolbar,
    toggleButton: {
        position: 'fixed',
        left: `${drawerWidth/2 - 15}px`,
        bottom: 20,
        zIndex: 1300,
        backgroundColor: '#014671',
        color: '#ffffff',
        border: '1px solid rgba(0, 0, 0, 0.08)',
        borderRadius: '4px',
        padding: 0,
        width: 20,
        height: 20,
        boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.3)',
        '&:hover': {
            backgroundColor: '#0b5e94',
        },
    },
    // Mobile-specific styles
    sidebarLogo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        flexDirection: 'row',
        padding: '15px 20px 5px',
        background: '#fff'
    },
    logoContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        maxWidth: '100%'
    },
    logo: {
        maxHeight: '32px',
        maxWidth: '180px',
        objectFit: 'contain'
    },
    zeroListPadding: {
        padding: '0'
    },
    userProfileDetails: {
        paddingLeft: '8px',
        textAlign: 'start'
    },
    listItemIconCenter: {
        alignItems: 'center'
    }
}))